/**
 * @fileoverview Authentication hook - provides global auth state and methods
 *
 * @example Basic usage
 * ```tsx
 * const { user, profile, signIn, signOut, hasRole, isAuthenticated } = useAuth()
 *
 * if (!isAuthenticated) return <LoginPage />
 * if (!hasRole('teacher')) return <Forbidden />
 * ```
 *
 * @example Available properties
 * - user: Supabase user object (id, email, etc.)
 * - profile: User profile from database (role, tenant_id, etc.)
 * - loading: Initial auth load state
 * - initialized: Auth system ready
 * - isAuthenticated: Boolean for logged in status
 *
 * @example Available methods
 * - signIn(email, password): Sign in user
 * - signUp(email, password, metadata): Register new user
 * - signOut(): Sign out and clear all storage
 * - hasRole(role | role[]): Check if user has role(s)
 * - validateInvitation(code): Validate invitation code
 * - linkInvitation(code): Link invitation to current user
 * - signUpWithInvitation(data): Sign up with invitation code
 */
import { useAuth as useAuthContext } from '@/contexts/AuthContext'

export const useAuth = useAuthContext